import { render } from "./background-task-details-modal.vue?vue&type=template&id=f1ead26a&ts=true"
import script from "./background-task-details-modal.vue?vue&type=script&lang=ts"
export * from "./background-task-details-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__